import React, { useEffect, useState } from 'react';
import { Button, Input, Layout, Space, Table } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useStore } from 'store';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const SePViewContracts = () => {
    const { t } = useTranslation();
    const userInfo = useStore((state) => state.user);
    const setLoading = useStore((state) => state.setLoading);

    //TABLE RESEARCH FUNCTIONS
    let searchInput: any;

    const [searchText, setSearchText] = useState<string>('');
    const [searchedColumn, setSearchedColumn] = useState<any>('');
    const [practices, setPractices] = useState<any[]>([]);

    const getColumnSearchProps = (dataIndex: any) => ({
        filterDropdown: (x: any) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={x.selectedKeys[0]}
                    onChange={(e) => x.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(x.selectedKeys, x.confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(x.selectedKeys, x.confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(x.clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            x.confirm({ closeDropdown: false });
                            setSearchText(x.selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    ></Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value: any, record: any) =>
            record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
        onFilterDropdownVisibleChange: (visible: any) => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: (text: any) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: any) => {
        clearFilters();
        setSearchText('');
    };

    const columns: any = [
        {
            title: t('commonClass.contractId'),
            dataIndex: 'contractId',
            key: '0',
            fixed: 'left',
            sorter: (a: any, b: any) => a.contractId.localeCompare(b.contractId),
            ...getColumnSearchProps('contractId'),
        },
        {
            title: t('commonClass.contractState'),
            dataIndex: 'contractState',
            key: '1',
            sorter: (a: any, b: any) => a.contractState.localeCompare(b.contractState),
            ...getColumnSearchProps('contractState'),
        },
        {
            title: t('commonClass.package'),
            dataIndex: 'package',
            key: '2',
            sorter: (a: any, b: any) => a.package.localeCompare(b.package),
            ...getColumnSearchProps('package'),
        },
        {
            title: t('vehicleClass.vehicle'),
            children: [
                {
                    title: t('vehicleClass.licensePlate'),
                    dataIndex: 'licensePlate',
                    key: '3',
                    sorter: (a: any, b: any) => a.licensePlate.localeCompare(b.licensePlate),
                    ...getColumnSearchProps('licensePlate'),
                },
                {
                    title: t('vehicleClass.brand'),
                    dataIndex: 'brand',
                    key: '4',
                    sorter: (a: any, b: any) => a.brand.localeCompare(b.brand),
                    ...getColumnSearchProps('brand'),
                },
                {
                    title: t('vehicleClass.model'),
                    dataIndex: 'model',
                    key: '5',
                    sorter: (a: any, b: any) => a.model.localeCompare(b.model),
                    ...getColumnSearchProps('model'),
                },
                {
                    title: t('vehicleClass.color'),
                    dataIndex: 'color',
                    key: '6',
                    sorter: (a: any, b: any) => a.color.localeCompare(b.color),
                    ...getColumnSearchProps('color'),
                },
            ],
        },
        {
            title: t('commonClass.contractor'),
            children: [
                {
                    title: t('customerClass.customer'),
                    dataIndex: 'customer',
                    key: '7',
                    sorter: (a: any, b: any) => a.customer.localeCompare(b.customer),
                    ...getColumnSearchProps('customer'),
                },
                {
                    title: t('customerClass.tel1'),
                    dataIndex: 'tel1',
                    key: '8',
                    sorter: (a: any, b: any) => a.tel1.localeCompare(b.tel1),
                    ...getColumnSearchProps('tel1'),
                },
                {
                    title: t('customerClass.emailAddress'),
                    dataIndex: 'emailAddress',
                    key: '9',
                    sorter: (a: any, b: any) => a.emailAddress.localeCompare(b.emailAddress),
                    ...getColumnSearchProps('emailAddress'),
                },
            ],
        } /*,
        {
            title: t("commonClass.actions"),
            dataIndex: 'actions',
            key: 'operations',
            fixed: 'right',
            render: () => <div><a href="/#">Edit</a> <a href="/#">Delete</a></div>,
        },
*/,
    ];

    useEffect(() => {
        const getPractices = async () => {
            setLoading(true);
            const practices = await SicuriProtettiServices.getPractices('SEP', userInfo.uid!);
            setPractices(practices);
            setLoading(false);
        };

        getPractices();
        // eslint-disable-next-line
    }, []);

    return (
        <Layout className="site-layout-background home-container center">
            <div>
                <Table bordered columns={columns} dataSource={practices} scroll={{ x: 1300, y: 500 }} />
            </div>
        </Layout>
    );
};

export default SePViewContracts;
